import React, { useCallback, useContext, useMemo } from 'react';
import Row from 'components/FeaturedSpreadsheet/components/Row';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import ScalarDatasheet from 'components/ScalarDatasheet';
import { SingleColumnProps } from './SingleColumn.props';

const SingleColumn = ({ className = '', data = [], isLegend = false, ...rest }: SingleColumnProps) => {
  const { deleteMultipleRowsFn } = useContext(FeaturedSpreadsheetContext);

  // By default, disable selection on fully read-only columns (e.g., company names)
  // since clicking them has no editing purpose. However, when batch-delete is enabled,
  // we must allow selection so users can select a range of rows to delete by clicking and dragging.
  const disableSheetSelection = useMemo(
    () => !deleteMultipleRowsFn && data.flat().every(cell => cell.readOnly),
    [data, deleteMultipleRowsFn]
  );

  const rowVariableLegend = useCallback(props => <Row {...props} isLegend={isLegend} />, [isLegend]);

  const singleColumnProps = useMemo(
    () => ({
      className,
      data,
      rowRenderer: rowVariableLegend,
      selected: disableSheetSelection ? null : undefined,
    }),
    [className, data, disableSheetSelection, rowVariableLegend]
  );

  return <ScalarDatasheet {...singleColumnProps} {...rest} />;
};

export default SingleColumn;
